export const SET_GROUPING = 'HOME/SET_GROUPING';

export const LOAD_LOCATION_DETAILS = 'LOAD_LOCATION_DETAILS';
export const LOAD_LOCATION_DETAILS_PENDING = 'LOAD_LOCATION_DETAILS_PENDING';
export const LOAD_LOCATION_DETAILS_FULFILLED =
  'LOAD_LOCATION_DETAILS_FULFILLED';
export const LOAD_LOCATION_DETAILS_REJECTED = 'LOAD_LOCATION_DETAILS_REJECTED';
